import { EntityTableCell } from '@fourthwall/components';
import React from 'react';
import * as S from './RoleListItem.styled';
export const RoleListItem = ({ role }) => {
    return (React.createElement(S.Container, null,
        React.createElement(EntityTableCell, { top: role.name, bottom: `${role.membersCount} members assigned` })));
};
